module.exports = __webpack_public_path__ + "img/3diamond-11.41f51010.svg";